import { ICurrentCareWizardStep } from '../types';

export const initialCareWizardDraft: ICurrentCareWizardStep = {
  currentStep: 1,
  originalInvoiceCost: 0,
  totalInvoiceSavings: 0,
  paymentDue: 0,
  additionalDiscountValue: 0,
  remainingExamCredits: 0,
  remainingCarePassValue: 0,
  examAmountToConsume: 0,
  examValueToConsume: 0,
  carePassValueToConsume: 0,
  additionalDiscountValueToConsume: 0,
  showPercentDiscountForm: false,
  includedExams: [],
  draftExamTotals: {},
  isBalanceSelected: false,
  selectedInvoiceId: null,
  careAccountCreditIntentId: null,
};
